import { useCallback, useId, useState } from "react";
import { DialogState } from "../../models/DialogState";

export function useResettableDialog<T>() {
  const [state, setState] = useState<DialogState<T>>({ mode: "closed" });
  const [counter, setCounter] = useState(0);
  const instanceId = useId();

  const key = `${instanceId}-${counter}`;

  const openAdd = useCallback(() => {
    setCounter(c => c + 1);
    setState({ mode: "add" });
  }, []);

  const openEdit = useCallback((item: T) => {
    setCounter(c => c + 1);
    setState({ mode: "edit", item });
  }, []);

  const close = useCallback(() => {
    setState(prev => ({ mode: "closed", item: prev.item }));
  }, []);

  return { state, key, openAdd, openEdit, close };
}
